export default {
	title: 'Avízo dožití',
	resultsSubheader: 'Výběr pojištěného pro avízo dožití',
	nameSurname: 'Příjmení a jméno',
	birthNumber: 'Rodné číslo',
	address: 'Adresa',
	noResults: 'Ke smlouvě nebylo možné dotáhnout pojištěné. Prosím vytvořte avízo dožití prostřednictvím PK.',
};
